module.exports = __webpack_public_path__ + "img/alabama-power-logo.c0ba80d9.jpg";